import { render, staticRenderFns } from "./VirHomePart3.vue?vue&type=template&id=e5dd45be&scoped=true&"
import script from "./VirHomePart3.vue?vue&type=script&lang=js&"
export * from "./VirHomePart3.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart3.vue?vue&type=style&index=0&id=e5dd45be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dd45be",
  null
  
)

export default component.exports